import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum ConfigurationPlanningPageTabId {
	Planning = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum ConfigurationPlanningPageViewId {
	Trimesters = 1,
	Staff = 2,
}


@Injectable({ providedIn: 'root' })
export class ConfigurationPlanningService extends PageTabsLayoutPageService<ConfigurationPlanningPageTabId, ConfigurationPlanningPageViewId> {

	private static readonly _viewDroplistItems: DroplistItem<never, ConfigurationPlanningPageViewId>[] = [
		{
			uniqueId: ConfigurationPlanningPageViewId.Trimesters,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Trimesters',
				hideText: 'never',
			},
			customSort: '1'
		},
		{
			uniqueId: ConfigurationPlanningPageViewId.Staff,
			iconContext: {
				iconClass: 'fa-people-group',
				iconStyle: 'fa-solid',
				text: 'Staff',
				hideText: 'never',
			},
			customSort: '3'
		},
	];

	constructor() {
		super(ConfigurationPlanningService._viewDroplistItems, ConfigurationPlanningService.name, ConfigurationPlanningPageTabId.Planning, ConfigurationPlanningPageViewId.Trimesters);
	}

	public get viewId() {
		return ConfigurationPlanningPageViewId;
	}

}